import { render, staticRenderFns } from "./StatusLegend.vue?vue&type=template&id=fbd91346&scoped=true&"
import script from "./StatusLegend.vue?vue&type=script&lang=js&"
export * from "./StatusLegend.vue?vue&type=script&lang=js&"
import style0 from "./StatusLegend.vue?vue&type=style&index=0&id=fbd91346&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd91346",
  null
  
)

export default component.exports